<template>
  <CallHelpTel />
  <div class="PublishContribution">
    <div class="pcWords">
      <p :style="{ fontSize: fontSize.p + 'em' }">
        歡迎您提供我們寶貴意見。<br />
        您所填寫的資料如涉及個人資料，如姓名、信箱等，本網站除用於回覆您的案件外，不會作其他用途，請您放心。
      </p>
    </div>
    <hr />
    <a-form
      ref="formRef"
      :model="formState"
      :rules="rules"
      @finish="onSubmit"
      @finishFailed="onFinishFailed"
    >
      <div class="type">
        <div>
          <!-- 寄件者 -->
          <a-form-item
            for="posterName"
            ref="posterName"
            label="寄件者"
            name="posterName"
            title="寄件者"
          >
            <a-input
              id="posterName"
              v-model:value.trim="formState.posterName"
              placeholder="請輸入寄件者，此欄位最多輸入200字"
              style="width: 70%"
              title="寄件者"
            />
          </a-form-item>
          <!-- 信箱 -->
          <a-form-item
            for="Email"
            ref="Email"
            label="Email"
            name="Email"
            title="Email"
          >
            <a-input
              id="Email"
              v-model:value="formState.Email"
              placeholder="請輸入聯絡信箱"
              style="width: 70%"
              title="信箱"
            />
          </a-form-item>
          <a-form-item
            label="問題類別"
            name="question_category"
            ref="question_category"
            title="問題類別"
          >
            <select
              class="ant-input"
              placeholder="請選擇問題類別"
              style="width: 69.4%"
              title="問題類別"
              v-model="formState.question_category"
            >
              <option
                v-for="select in select_list"
                :key="select.nodeId"
                :value="select.nodeId.toString()"
                title="問題類別"
              >
                {{ select.nodeName }}
              </option>
            </select>
          </a-form-item>
          <!-- 信件主旨 -->
          <a-form-item
            for="Email_title"
            ref="Email_title"
            label="信件主旨"
            name="Email_title"
          >
            <a-input
              id="Email_title"
              v-model:value="formState.Email_title"
              placeholder="請輸入信件主旨，此欄位最多輸入30字"
              style="width: 69.4%"
              title="信件主旨"
            />
          </a-form-item>
        </div>
        <!-- 信件內容 -->
        <div>
          <a-form-item
            label="信件內容"
            class="content"
            for="contentArea"
            name="content"
            title="信件內容"
          >
            <a-textarea
              id="contextArea"
              v-model:value="formState.content"
              placeholder="請輸入信件內容，每篇上限為1000字。"
              showCount
              :maxlength="1000"
              :auto-size="{ minRows: 15, maxRows: 1000 }"
              title="信件內容輸入框"
            />
          </a-form-item>
        </div>
        <div class="verification_code">
          <!-- 驗證碼 -->
          <a-form-item for="code" ref="code" label="驗證碼" name="code">
            <a-input
              id="code"
              v-model:value="formState.code"
              placeholder="請輸入大小寫驗證碼"
              title="驗證碼"
            />
            <p cless="red_txt">英文需區分大小寫</p>
          </a-form-item>
          <div class="re_group">
            <div class="get-code" @click="refreshCode()" value="驗證碼">
              <s-identify
                :identifyCode="identifyCode"
                title="驗證碼"
              ></s-identify>
            </div>

            <a-button
              class="reorganize"
              @click="refreshCode"
              
            >
              <i class="fas fa-sync-alt"></i>變更驗證碼
            </a-button>

            <a-button
              @click="speak(identifyCode)"
             
              class="reorganize"
            >
              <i class="fas fa-play"></i>播放語音驗證碼
            </a-button>
          </div>
        </div>
      </div>
      <div class="btn_group">
        <a-button type="primary" value="完成送出" html-type="submit">
          <p :style="{ fontSize: fontSize.p + 'em' }">完成送出</p>
        </a-button>

        <a-button
          class="write_again"
          @click="formRef.resetFields()"
          value="重新輸入"
        >
          <p :style="{ fontSize: fontSize.p + 'em' }">重新輸入</p>
        </a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, inject, onMounted } from "vue";
import { apiContact_s, apiContact } from "@/api/api.js";
import { emailValidate } from "@/func.js";
import Swal from "sweetalert2";
import SIdentify from "./sIdentify.vue";
import CallHelpTel from "../components/Home/CallHelpTel.vue";

export default defineComponent({
  name: "ServiceEmail",
  components: {
    SIdentify,
    CallHelpTel,
  },

  setup() {
    onMounted(() => {
      speechInit();
    });

    const speechInit = () => {
      if (typeof window !== "undefined" && window.speechSynthesis) {
        window.speechSynthesis.getVoices();
      }
    };
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    const formRef = ref();
    // 問題類別
    const select_list = ref([]);

    // 驗證碼
    const identifyCode = ref("");
    const identifyCodes = ref("0123456789abcdwerwshdjeJKDHRJHKOOPLMKQ");
    const randomNum = (min, max) => {
      max = max + 1;
      return Math.floor(Math.random() * (max - min) + min);
    };
    const makeCode = (data, len) => {
      for (let i = 0; i < len; i++) {
        identifyCode.value += data[randomNum(0, data.length - 1)];
      }
    };

    const refreshCode = () => {
      identifyCode.value = "";
      makeCode(identifyCodes.value, 4);
    };

    refreshCode();

    //

    const formState = reactive({
      posterName: "",
      Email: "",
      question_category: "",
      Email_title: "",
      content: "",
      code: "",
      testTitle: "測試",
    });

    const rules = {
      posterName: [
        {
          required: true,
          message: "請輸入寄件者",
          trigger: "blur",
        },
        {
          min: 2,
          max: 200,
          message: "此欄位長度限制2-200字元",
          trigger: "blur",
        },
      ],

      Email: [
        {
          required: true,
          validator: emailValidate,
          trigger: "blur",
        },
      ],

      question_category: [
        {
          required: true,
          message: "請選擇問題類別",
          trigger: "change",
        },
      ],

      Email_title: [
        {
          required: true,
          message: "請輸入信件主旨",
          trigger: "blur",
        },
        {
          min: 2,
          max: 30,
          message: "此欄位長度限制2-30字元",
          trigger: "blur",
        },
      ],

      content: [
        {
          required: true,
          message: "請輸入信件內容",
          trigger: "change",
        },
      ],

      code: [
        {
          required: true,
          message: "請輸入驗證碼",
          trigger: "blur",
        },
      ],
    };

    //取得問題類別
    apiContact_s()
      .then((res) => {
        select_list.value = res.data;
      })
      .catch((err) => {
        console.log("取得問題類別失敗", err);
      });

    // 送出表單
    const onSubmit = async () => {
      if (formState.code === identifyCode.value) {
        apiContact({
          posterName: formState.posterName,
          posterEmail: formState.Email,
          nodeId: formState.question_category,
          title: formState.Email_title,
          content: formState.content,
          testTitle: formState.testTitle,
        })
          .then((res) => {
            formRef.value.resetFields();
            Swal.fire(
              "<h3>送出成功！<br/><h6>我們已經收到您的來函，請靜候回覆，感謝。",
              "",
              "success"
            );
          })
          .catch((err) => {
            console.log(err);
            Swal.fire("送出失敗!", "您未成功投稿唷", "error");
          });
      } else Swal.fire("驗證失敗!", "驗證碼錯誤", "error");
    };
    const onFinishFailed = ({ errorFields }) => {
      document.getElementById(errorFields[0].name).focus();
    };
    const speak = (t) => {
      if (typeof window === "undefined" || !window.speechSynthesis) {
        Swal.fire("裝置不支援語音播放", "請改用畫面上的驗證碼", "info");
        return;
      }

      const utterance = new SpeechSynthesisUtterance(
        `${t[0]} ${t[1]} ${t[2]} ${t[3]}`
      );
      utterance.lang = "zh-TW";
      utterance.rate = 0.5;
      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(utterance);
    };
    return {
      // labelCol: {
      //   span: 4,
      // },
      // wrapperCol: {
      //   span: 14,
      // },
      formRef,
      formState,
      rules,
      onSubmit,
      onFinishFailed,
      fontSize,
      refreshCode,
      identifyCode,
      identifyCodes,
      select_list,
      speak,
    };
  },
});
</script>

<style lang="scss" scoped>
.type {
  background-color: #f9f9f9;
  padding: 20px;
  margin: 32px 0;
  border-radius: 5px;
}

hr {
  border: solid 3px $main_color;
  margin: 10px 0;
}

.ant-input {
  padding: 5px;
}

.PublishContribution {
  text-align: left;

  .pcWords {
    padding: 20px;

    ul {
      li {
        margin-bottom: 10px;
      }
    }
  }
}

.ant-form-item-control-input-content {
  width: 60%;
}

.verification_code {
  display: flex;
  align-items: flex-start;

  @include sm {
    flex-direction: column;
    align-items: flex-start;
  }

  p {
    font-size: 1em;
    color: #ff4d4f;
  }
}

.re_group {
  display: flex;
  align-items: center;

  .get-code {
    background-color: #eee;
    height: fit-content;
    margin-left: 8px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    margin-bottom: 24px;

    @include sm {
      margin-bottom: 8px;
      margin-left: 0;
    }
  }
  .ant-btn {
    height: auto;
    padding: 4px 16px;

    &:focus {
      outline: 2px solid black;
      outline-offset: 2px;
    }
  }
  .reorganize {
    border: 1.5px solid #d9d9d9;
    border-radius: 2px;
    padding: 4px 8px;
    margin-left: 8px;
    margin-bottom: 24px;
    background-color: #fff;
    transition: all 0.3s;

    @include sm {
      margin-bottom: 8px;
    }

    .fa-sync-alt,
    .fa-play {
      color: #6b6b6b;
    }

    &:hover {
      transition: all 0.3s;
      background-color: #024d73;
    }

    &:hover .fa-sync-alt {
      transition: all 0.3s;
      color: #fdde5d;
    }

    &:hover .fa-play {
      transition: all 0.3s;
      color: #fdde5d;
    }
  }
}

.ant-row {
  @include sm {
    margin-bottom: 8px;
  }
}

.btn_group {
  display: flex;
  justify-content: center;
  transition: all 0.3s;

  @include sm {
    flex-direction: column;
  }

  .ant-btn {
    height: auto;
    padding: 4px 16px;

    &:focus {
      outline: 2px solid black;
      outline-offset: 2px;
    }
  }

  .ant-btn-primary:hover p {
    transition: all 0.3s;
    color: #fdde5d;
  }

  .write_again {
    margin-left: 56px;

    @include sm {
      margin-left: 0;
      margin-top: 16px;
    }
  }
}
</style>
